module.exports = __webpack_public_path__ + "img/download-light.9a75d157.svg";